import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import TokenListCard from "@/components/Tokens/TokenListCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenList',
  props: {
  pages: { type: Array, default: null },
},
  setup(__props) {

const props = __props;

const allTokens = computed(() =>
  props.pages?.length ? props.pages.map((page) => page.items).flat() : []
);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTokens.value, (token) => {
        return (_openBlock(), _createBlock(_component_v_col, {
          cols: "12",
          md: "6",
          lg: "4",
          key: token.id
        }, {
          default: _withCtx(() => [
            _createVNode(TokenListCard, { token: token }, null, 8, ["token"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})